// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"ND-z","smallCardRow":"OD-z","largeCardRow":"PD-z","productSearchRow":"QD-z","curatedRow":"RD-z"};